export const ActionRequiredConfig = {
    name            : 'Action required',
    icon            : 'i5-user-action-required',
    image           : 'action-required',
    iconSvg         : 'isvg-view-action-required',
    url             : 'action-required',
    description     : 'Summary of action required tasks by user and scheduled day.',
    canBeInProject  : true,
}

export const CUSTOM_VIEW_ACTION_REQUIRED_CONFIG = {
    ...ActionRequiredConfig,
    // key2: "newValue2",  // Replacing the value for key2
}